import type { Service } from "./types";
import { BarsIcon } from "@/components/icons/services/bars-icon";
import { BrainIcon } from "@/components/icons/services/brain-icon";
import { CartIcon } from "@/components/icons/services/cart-icon";
import { CloudIcon } from "@/components/icons/services/cloud-icon";
import { DataIcon } from "@/components/icons/services/data-icon";
import { DollarIcon } from "@/components/icons/services/dollar-icon";
import { LinkIcon } from "@/components/icons/services/link-icon";
import { MobileIcon } from "@/components/icons/services/mobile-icon";
import { SparklesIcon } from "@/components/icons/services/sparkles-icon";

export const services: Service[] = [
  {
    icon: <SparklesIcon className="w-6 h-6" />,
    iconBg: "bg-black/20 border border-[#353739]",
    title: "LLM Workflow Automation",
    description: "Automate document processing, intake, and structured extraction over the data we already plumb."
  },
  {
    icon: <LinkIcon className="w-6 h-6" />,
    iconBg: "bg-black/20 border border-[#353739]",
    title: "NetSuite & Celigo Builds",
    description: "Connect Shopify, Stripe, and Recharge to NetSuite with revenue and order data reconciled automatically."
  },
  {
    icon: <BrainIcon className="w-6 h-6" />,
    iconBg: "bg-black/20 border border-[#353739]",
    title: "Multi-Touch Attribution",
    description: "Map every customer journey with Markov, Shapley, and blended models across all your ad platforms."
  },
  {
    icon: <BarsIcon className="w-6 h-6" />,
    iconBg: "bg-black/20 border border-[#353739]",
    title: "Revenue Dashboards",
    description: "Track first purchase, orders, and LTV in dashboards your team reads at a single glance."
  },
  {
    icon: <MobileIcon className="w-6 h-6" />,
    iconBg: "bg-black/20 border border-[#353739]",
    title: "Mobile App Development",
    description: "Launch your MVP with React Native and Expo, including app store submission and optimisation."
  },
  {
    icon: <CloudIcon className="w-6 h-6" />,
    iconBg: "bg-black/20 border border-[#353739]",
    title: "Source Data Pipelines",
    description: "Ingest from every source into one warehouse with idempotent, retry-safe, and observable jobs."
  },
  {
    icon: <DataIcon className="w-6 h-6" />,
    iconBg: "bg-black/20 border border-[#353739]",
    title: "Identity Resolution",
    description: "Stitch fragmented events into a single customer identity across every device and session."
  },
  {
    icon: <CartIcon className="w-6 h-6" />,
    iconBg: "bg-black/20 border border-[#353739]",
    title: "EDI & Multi-3PL Routing",
    description: "Custom EDI maps (850, 810, 856, 940) with multi-3PL order routing and automated returns handling."
  },
  {
    icon: <DollarIcon className="w-6 h-6" />,
    iconBg: "bg-black/20 border border-[#353739]",
    title: "Contribution Margin",
    description: "Blend ad spend, 3PL costs, and processor fees into NetSuite so CAC, payback period, and margin stay true."
  }
];